import { useEffect, useRef } from 'react';

/**
 * <b>? 버튼을 화면이 대신 받는</b> 자리 (사용자 지시 2026-11-02).
 *
 * <p>현장 조회의 수행관리 탭에서는 ? 가 전체 안내를 펴지 않고 「작성 안내가 필요하신가요?」 창을
 * 다시 띄운다 — 처음 들어갈 때 한 번 묻고 닫은 그 창을 다시 여는 길이 ? 다. 화면이 손을 들고 있는
 * 동안만 그렇고, 손을 내리면(탭을 옮기거나 화면을 떠나면) ? 는 늘 하던 대로 전체 안내다.
 */

let handler: (() => void) | null = null;

/** ? 를 눌렀을 때 AppLayout 이 먼저 부른다. 화면이 받았으면 true — 전체 안내를 펴지 않는다. */
export function runHelpOverride(): boolean {
  if (!handler) return false;
  handler();
  return true;
}

/** {@code active} 인 동안 ? 를 {@code onHelp} 가 받는다. */
export function useHelpOverride(onHelp: () => void, active: boolean): void {
  const latest = useRef(onHelp);
  latest.current = onHelp;

  useEffect(() => {
    if (!active) return;
    const mine = () => latest.current();
    handler = mine;
    return () => {
      if (handler === mine) handler = null;
    };
  }, [active]);
}
